import { UGOInputsVM } from '../UGOInputs/UGOInputsVM';
import stores from 'cd-eft/models/Stores';

const { ugoDesignStore } = stores.AppStore;

export interface IPipeInputsProps {
  ugoInputsConfig?: any;
  inputForms?: any;
  redHighlighting?: any;
  canSetPressureFlow?: any;
  hasSectionChanged?: any;
  formsValidation?: any;
}

export class UGOPipeInputsVM extends UGOInputsVM {
  props: IPipeInputsProps;

  constructor(props: IPipeInputsProps) {
    super(props);
    this.props = props;
    if (props.ugoInputsConfig) {
      this.ugoInputsConfig = props.ugoInputsConfig;
      ugoDesignStore.inputForms = props.inputForms;
      this.redHighlighting = props.redHighlighting;
      this.canSetPressureFlow = props.canSetPressureFlow;
      this.hasSectionChanged = props.hasSectionChanged;
      this.formsValidation = props.formsValidation;
    }
  }
}
